module.exports = __webpack_public_path__ + "img/heatloss_small.5a537544.jpg";